/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WatchdogDefinition } from './WatchdogDefinition';
import {
    WatchdogDefinitionFromJSON,
    WatchdogDefinitionFromJSONTyped,
    WatchdogDefinitionToJSON,
} from './WatchdogDefinition';

/**
 * 
 * @export
 * @interface DefinitionGet200Response
 */
export interface DefinitionGet200Response {
    /**
     * 
     * @type {Array<WatchdogDefinition>}
     * @memberof DefinitionGet200Response
     */
    records?: Array<WatchdogDefinition>;
}

/**
 * Check if a given object implements the DefinitionGet200Response interface.
 */
export function instanceOfDefinitionGet200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DefinitionGet200ResponseFromJSON(json: any): DefinitionGet200Response {
    return DefinitionGet200ResponseFromJSONTyped(json, false);
}

export function DefinitionGet200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DefinitionGet200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'records': !exists(json, 'records') ? undefined : ((json['records'] as Array<any>).map(WatchdogDefinitionFromJSON)),
    };
}

export function DefinitionGet200ResponseToJSON(value?: DefinitionGet200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'records': value.records === undefined ? undefined : ((value.records as Array<any>).map(WatchdogDefinitionToJSON)),
    };
}

